import { useState } from 'react';

import { LanguagesOptions } from 'schema/locale';
import { QAStoreOptions } from 'schema/storeCode';
import StoreIcon from 'shared/components/StoreIcon/StoreIcon';
import { getShortLocale } from 'shared/utils/locale';
import { useLocale } from 'shared/hooks/useLocale';
import RegionSelectorModal from 'shared/components/RegionSelectorModal/RegionSelectorModal';

import styles from './styles.module.scss';
import { useFooterContext } from '../../FooterContext';
import { useStoreValue } from '../../../../../state/hooks/useStore';

const FooterStoreInfo = () => {
  const locale = useLocale();
  const [opened, setOpened] = useState(false);
  const {
    data: { regionSelector },
    pageTranslations
  } = useFooterContext();

  const store = useStoreValue();

  const localeLabel = LanguagesOptions.find((item) => getShortLocale(locale) === item.value)?.label;

  const storeLabel = QAStoreOptions.find((item) => item.value === store)?.label;

  const handleOpenModal = () => {
    setOpened(true);
  };

  const handleCloseModal = () => {
    setOpened(false);
  };

  return (
    <>
      <button
        className={styles.wrapper}
        type="button"
        onClick={handleOpenModal}
        data-testid="region-settings-button">
        <StoreIcon className={styles.storeIcon} />
        <span>{localeLabel}</span>
        <span>|</span>
        <span>{storeLabel}</span>
      </button>
      <RegionSelectorModal
        isOpen={opened}
        onClose={handleCloseModal}
        pageTranslations={pageTranslations || []}
        text={regionSelector}
      />
    </>
  );
};

export default FooterStoreInfo;
